import { CheckIcon } from "@heroicons/react/24/outline";
import Button from "../components/button/Button";
import { useNavigate, useLocation } from "react-router-dom";

export const RegisterSend = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const state = location.state ;

  return (
    <>
      <div className="bg-[#fcfafd] flex min-h-full flex-col justify-center sm:px-6 lg:px-8">
        <div className="flex sm:mx-auto sm:w-full sm:max-w-md">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
          </div>
          <h2 className="text-center pt-1 text-3xl font-bold tracking-tight text-gray-900">
            確認用メールを送信しました
          </h2>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form
              className="space-y-6"
              method="POST"
            >
              <div>
                <label
                  htmlFor="email"
                  className="text-left  block text-sm font-medium text-gray-700"
                >
                  メールアドレス
                </label>
                <div className="mt-1">
                  <label
                    htmlFor="email"
                    className="text-left  block text-sm font-medium text-gray-700"
                  >
                    {state}
                  </label>
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="text-left block text-sm font-medium text-gray-800"
                >
                  確認メールを送信しました。
                </label>
                <div className="mt-1">
                  <label
                    htmlFor="password"
                    className="text-left block text-sm font-medium text-gray-700"
                  >
                    メールの内容を確認して、登録を完了してください。
                  </label>
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="text-left block text-sm font-medium text-gray-700"
                >
                  確認メールは
                </label>
                <div className="mt-1">
                  <label
                    htmlFor="password"
                    className="text-left block text-sm font-medium text-gray-800"
                  >
                    「no-reply@admin.event-support.site」
                  </label>
                  <div className="mt-1"></div>
                  <label
                    htmlFor="password"
                    className="text-left block text-sm font-medium text-gray-700"
                  >
                    から送信されます。
                  </label>
                </div>
              </div>

              <div className="pt-3">
                <Button submit={true} className="text-sm" block={true}>
                  メールの再送
                </Button>
                <label
                  className="pt-2 text-right block text-xs font-medium text-indigo-700"
                  onClick={() => navigation("/register")}
                >
                  別のアドレスで登録する
                </label>
                <label
                  className="pt-2 text-right block text-xs font-medium text-indigo-700"
                  onClick={() => navigation("/login")}
                >
                  ログイン画面へ
                </label>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
